export default "__VITE_ASSET__BA_36iDo__"